module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "message"
  }, [_c('div', {
    staticClass: "message__pic"
  }), _c('div', {
    staticClass: "message__block"
  }, [(_vm.msg.text.title) ? _c('h3', {
    staticClass: "message__block__title"
  }, [_vm._v(_vm._s(_vm.msg.text.title))]) : _vm._e(), (_vm.msg.text.warning) ? _c('p', {
    staticClass: "message__block__text success__text_warning"
  }, [_vm._v(_vm._s(_vm.msg.text.warning))]) : _vm._e(), (_vm.msg.text.description) ? _c('p', {
    staticClass: "message__block__text",
    class: {
      error_text: _vm.msg.type === "error"
    }
  }, [_vm._v(_vm._s(_vm.msg.text.description))]) : _vm._e(), _c('Button', {
    staticClass: "message__block__btn",
    attrs: {
      "size": "normal",
      "color": "green"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("Да, понятно")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ce5aa62","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ordersProcessForms/parts/finishMessage/FinishMessage.vue
// module id = 030f97b56505582ff809
// module chunks = 0